import React, { useEffect, useRef, useState } from 'react';
import II18 from '../translate/II18';
import { Button, Link, Navbar, NavRight, Page, Popup } from 'framework7-react';

import PropTypes from 'prop-types';
import UserCredentialsFields from './UserCredentialsFields';

export default function UserCredentialsForm(props) {
  const fieldsRef = useRef(null);
  const [sendButtonClicked, setSendButtonClicked] = useState(false);
  const [usersDataOk, setUsersDataOk] = useState(false);

  useEffect(() => {
    if (sendButtonClicked) {
      setTimeout(props.onClick, 50);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sendButtonClicked]);

  useEffect(() => {
    if (!props.opened) {
      setSendButtonClicked(false);
    }
  }, [props.opened]);

  const formContent = (
    <>
      <UserCredentialsFields
        ref={fieldsRef}
        usersData={props.usersData}
        usersDataOk={props.usersDataOk}
        region={props.region}
        active={props.opened}
        onValidityChange={setUsersDataOk}
      />

      {!props.hideActions && (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            marginTop: 10,
            marginBottom: 30
          }}
        >
          <Button
            id={'sendDocumentsAndUserDataButton'}
            className={usersDataOk ? 'active' : 'notactive'}
            color={usersDataOk ? 'green' : 'gray'}
            raised
            fill
            disabled={!usersDataOk || sendButtonClicked}
            style={{
              maxWidth: 350,
              lineHeight: '48px',
              height: 48,
              fontSize: 16,
              padding: '0 30px',
              color: usersDataOk ? 'white' : '#cfcfcf',
              backgroundColor: usersDataOk ? 'green' : '#eae9e9',
              boxShadow: usersDataOk ? {} : 'none'
            }}
            onClick={() => {
              const merged = fieldsRef.current?.getMergedUsersData();
              if (merged) {
                props.setUsersData(merged);
              }
              setSendButtonClicked(true);
            }}
          >
            <span>
              {II18.get(
                props.sendTitle || props.completeButtonLabel || 'list_send_docs'
              )}
            </span>
          </Button>
        </div>
      )}
    </>
  );

  return props.renderContentOnly ? (
    formContent
  ) : (
    <Popup
      key={props.popupId}
      id={props.popupId || 'user_credentials_popup'}
      opened={props.opened}
      className="userCredentialsForm"
      closeByBackdropClick={false}
      closeOnEscape={false}
    >
      <Page>
        <Navbar title={II18.get('user_credentials_title')}>
          {props.disableClose !== true && (
            <NavRight>
              <Link onClick={props.onCancel}>
                <II18>title_close</II18>
              </Link>
            </NavRight>
          )}
        </Navbar>

        {formContent}
      </Page>
    </Popup>
  );
}

UserCredentialsForm.propTypes = {
  popupId: PropTypes.string,
  onClick: PropTypes.func,
  onCancel: PropTypes.func,
  disableClose: PropTypes.bool,
  renderContentOnly: PropTypes.bool,
  hideActions: PropTypes.bool,
  opened: PropTypes.bool,
  sendTitle: PropTypes.string,
  completeButtonLabel: PropTypes.string,
  region: PropTypes.string,
  usersData: PropTypes.array,
  setUsersData: PropTypes.func,
  usersDataOk: PropTypes.func
};
